export default [
    /*** 推广人员 ***/
    {
        path: '/distribution/personnel',
        component: () => import('../pages/distribution/personnel/index.vue'),
        meta: { title: '推广人员' }
    },
    /*** 推广商品 ***/
    {
        path: '/distribution/product',
        component: () => import('../pages/distribution/product/index.vue'),
        meta: { title: '推广商品' }
    },
    /*** 人员审核 ***/
    {
        path: '/distribution/examine',
        component: () => import('../pages/distribution/examine/index.vue'),
        meta: { title: '人员审核' }
    },
    /*** 推广订单 ***/
    {
        path: '/distribution/order',
        component: () => import('../pages/distribution/order/index.vue'),
        meta: { title: '推广订单' }
    },
    /*** 累计收益 ***/
    {
        path: '/distribution/personnel/profitdetail',
        component: () => import('../pages/distribution/personnel/profitdetail.vue'),
        meta: { title: '累计收益' }
    },
    /*** 帮助中心 ***/
    {
        path: '/distribution/help',
        component: () => import('../pages/distribution/help/index.vue'),
        meta: { title: '帮助中心' }
    },
    /*** 邀请列表 ***/
    {
        path: '/distribution/personnel/invite',
        component: () => import('../pages/distribution/personnel/invite.vue'),
        meta: { title: '邀请列表' }
    },
    /*** 分销设置 ***/
    {
        path: '/distribution/settings',
        component: () => import('../pages/distribution/settings/index.vue'),
        meta: { title: '分销设置' }
    },
    {
        path: '/distribution/recommend',
        component: () => import('../pages/distribution/recommend/index.vue'),
        meta: { title: '分销推广' }
    }
]